import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DropzoneComponent from 'react-dropzone-component';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

// Redux Action

// Style
import s from '!isomorphic-style-loader!css-loader!./filepicker.css';

// Component
import PhotosList from '../PhotosList';
import { Text } from '../../common';
import { photoUploadUrl } from '../../../config';
import { observer } from 'mobx-react';

@observer
class PhotosUpload extends Component {
  static propTypes = {
    createListingPhotos: PropTypes.func,
    removeListingPhotos: PropTypes.func,
  };

  constructor(props) {
    super(props);
    this.success = this.success.bind(this);
    this.complete = this.complete.bind(this);
    this.dropzone = null;
  }

  componentDidMount() {
    const isBrowser = typeof window !== 'undefined';
    const isDocument = typeof document !== undefined;
    if (isBrowser && isDocument) {
      document.querySelector('.dz-hidden-input').style.visibility = 'visible';
      document.querySelector('.dz-hidden-input').style.opacity = '0';
      document.querySelector('.dz-hidden-input').style.height = '100%';
      document.querySelector('.dz-hidden-input').style.width = '100%';
      document.querySelector('.dz-hidden-input').style.cursor = 'pointer';
    }
  }

  success(file, fromServer) {
    /*const { listId, createListingPhotos } = this.props;
    const { files } = fromServer;
    let fileName = files[0].filename;
    let fileType = files[0].mimetype;
    // Calling Redux action to create a record for uploaded file
    if(listId != undefined) {
      createListingPhotos(listId, fileName, fileType);
    }*/
  }

  complete(file) {
    const {
      store: { listId },
      savePhotos,
    } = this.props;
    // console.log('UPLOAD COMPLETE');
    if (file && file.xhr && file.status !== 'error') {
      const parsed = JSON.parse(file.xhr.response);
      const files = parsed.files;
      const oneFile = parsed.file;
      if (oneFile.key || oneFile.filename) {
        let fileName = oneFile.key ? oneFile.key : oneFile.filename;
        let fileType = oneFile.mimetype;
        if (listId != undefined) {
          savePhotos(fileName, fileType);
        }
        this.dropzone.removeFile(file);
      } else if (files && files.length > 0) {
        let fileName = files[0].key ? files[0].key : files[0].filename;
        let fileType = files[0].mimetype;
        if (listId != undefined) {
          savePhotos(fileName, fileType);
        }
        this.dropzone.removeFile(file);
      }
    }
  }

  render() {
    const { placeholder, store, removeListingPhoto, small } = this.props;
    const djsConfig = {
      dictDefaultMessage: placeholder,
      addRemoveLinks: false,
      maxFilesize: 10,
      maxFiles: 20,
      acceptedFiles: 'image/*',
      hiddenInputContainer: '.dzInputContainer',
    };
    const componentConfig = {
      iconFiletypes: ['.jpg', '.png'],
      // showFiletypeIcon: true,
      postUrl: photoUploadUrl,
    };
    const eventHandlers = {
      init: dz => (this.dropzone = dz),
      success: this.success,
      complete: this.complete,
    };

    return (
      <div className={cx('listPhotoContainer')}>
        <div className={cx('dzInputContainer')}>
          <DropzoneComponent
            config={componentConfig}
            eventHandlers={eventHandlers}
            djsConfig={djsConfig}
          />
        </div>

        <Text header grayDarkMedium>
          Select your cover photo below
        </Text>
        <PhotosList
          listId={store.listId}
          store={store}
          small={small}
          removeListingPhoto={removeListingPhoto}
        />
      </div>
    );
  }
}

export default withStyles(s)(PhotosUpload);



// WEBPACK FOOTER //
// ./src/components_new/addListing/PhotoUpload/PhotosUpload.js